var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.5,
    height: 31.301,
    viewBox: "0 0 39.5 31.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-268.25 -799.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M176.461,443.823v.832H144v-3.329a3.046,3.046,0,0,1,.133-.916,3.336,3.336,0,0,1,3.2-2.414h.832a3.339,3.339,0,0,1,3.329,3.329l.441.108c2.048-2.089,4.478-3.6,6.925-3.446,3.146.191,11.586.841,11.586.841C174.313,439.195,176.461,441.117,176.461,443.823Z",
    transform: "translate(130.539 373.553)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269 800)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M153.24,426.422l2.415-1.358-.662,4.519,2.433-1.369",
    transform: "translate(-139.837 -422.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163.237,422.779l3.337-.485-2.73,4.841,3.362-.488",
    transform: "translate(-141.582 -422.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.228,422l3.894.336-4.362,4.74,3.923.339",
    transform: "translate(-143.451 -422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.783,443.018V432.156A3.342,3.342,0,0,0,139.411,429H137v23.913h5.14l1.8-4.123H168.01l1.8,4.123H175v-9.895Z",
    transform: "translate(-137 -423.174)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M177.836,444.654v-.832c0-2.712-2.142-4.634-6.01-4.994,0,0-8.443-.657-11.586-.844-2.906-.173-5.776,1.974-8.037,4.668",
    transform: "translate(-139.836 -424.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144,441.329h0A3.339,3.339,0,0,1,147.329,438h.832a3.339,3.339,0,0,1,3.329,3.329h0",
    transform: "translate(-138.228 -424.795)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 0.572,
    transform: "translate(13.217 16.519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.3fc4dd01a93784e392f6ff8ea6c18d31.svg";
export { ForwardRef as ReactComponent };